import { render } from "./form2page.vue?vue&type=template&id=784db73f&scoped=true"
import script from "./form2page.vue?vue&type=script&lang=js"
export * from "./form2page.vue?vue&type=script&lang=js"

import "./form2page.vue?vue&type=style&index=0&id=784db73f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784db73f"]])

export default __exports__